// studioStyles.js — shared Studio chrome style fragments (gass_front design
// system adoption, Phase 3 restyle).
//
// Small spreadable style objects for the recurring Studio shapes: pill
// buttons, cards, floating menus, section headers, and the accent-fill /
// accent-wash states. Components spread these instead of repeating the same
// inline objects (same JS-style-module idiom as versionControl/vcStyles.js).
//
// Every VALUE rides the --m-* token contract (src/lib/palettes/tokens.js), so
// a legacy palette resolves its pre-Studio radii/shadows and keeps its look,
// while the Studio pair resolves the design system's. The one shape-only
// constant — the 999px pill radius — is palette-independent by design: a pill
// is a pill in every theme.

/** UI chrome typeface — labels, buttons, menu items, panel titles, copy.
 *  Rides the token so every palette resolves the shipped Hanken Grotesk. */
export const UI_FONT = 'var(--m-font)'

/** Monospace typeface — code/data readouts only: ids, hashes, numeric xyz
 *  fields, console output, keyboard-shortcut key labels, counts. */
export const MONO = 'var(--m-mono)'

/** Fully-rounded pill geometry + type, per gass .stu-btn. Spread onto buttons
 *  and chips; callers keep their own padding/colors. */
export const pill = {
  borderRadius: 999,
  fontWeight: 700,
  transition: 'background var(--m-ease), color var(--m-ease), border-color var(--m-ease), opacity var(--m-ease)',
}

/** Card / panel surface, per gass .stu-panel / .stu-card. */
export const card = {
  borderRadius: 'var(--m-radius)',
  boxShadow: 'var(--m-shadow-card)',
}

/** Floating menu / dropdown surface, per gass .stu-menu (12px-ish radius under
 *  the Studio palettes, the legacy 8px under LEGACY_CHROME). */
export const menuSurface = {
  borderRadius: 'calc(var(--m-radius-sm) + 4px)',
  boxShadow: 'var(--m-shadow-card)',
}

/** Section-header type, per gass .stu-panel-head: small, bold, uppercase,
 *  tracked-out, muted. */
export const head = {
  fontSize: 'var(--m-head-size)',
  fontWeight: 700,
  letterSpacing: 'var(--m-head-ls)',
  textTransform: 'uppercase',
  color: 'var(--m-fg-2)',
}

/** Primary / accent action: accent fill with its declared ink. */
export const accentFill = {
  background: 'var(--m-accent)',
  color: 'var(--m-accent-ink)',
}

/** Active / selected state: accent-soft wash + accent text (gass .active
 *  rows) — never a heavy border. */
export const activeWash = {
  background: 'var(--m-accent-soft)',
  color: 'var(--m-accent)',
}
